const EntityStatus = require('@/lib/Entities/EntityStatus');
const { toInt, toString } = require('@/functions/transform');

/**
 * @abstract
 */
class AbstractEntity {
    constructor() {
        /**
         * @type {Number}
         */
        this.ID = null;

        /**
         * @type {number}
         */
        this.navOrder = 0;

        /**
         * @type {String}
         */
        this.status = EntityStatus.ACTIVE;
    }

    /**
     * @return {boolean}
     */
    isActive() {
        return this.status === EntityStatus.ACTIVE;
    }

    getHydrationMap() {
        return {
            ID: toInt,
            navOrder: toInt,
            status: toString,
        };
    }
}

module.exports = AbstractEntity;
